import React from 'react'

import { SizeGuideFits } from '@Domains/Cart/Components/Prompt/types'

type SizeGuideFitsContextType = {
  fits: SizeGuideFits[]
  onChangeSize: (size: string) => void
}

export const SizeGuideFitsContext = React.createContext<SizeGuideFitsContextType>({
  fits: [],
  onChangeSize: () => {},
})
